module.exports = __webpack_public_path__ + "static/media/echangemobilier.b61c7099.jpg";